// src/components/legal/PieLegal.jsx
//
// LA LEYENDA LEGAL DEL PIE (LEGAL.md, L5)
//
// Rob: «una pequeña leyenda para ver esos apartados […] cuando entras a una
// página web». Es esto: los tres documentos y el correo, en una línea.
//
// Un solo componente para todos los pies —la landing, la de empresas, el
// registro— porque el día que cambie el correo o entre un documento nuevo, un
// enlace olvidado en otra pantalla es un enlace roto que nadie mira.
//
// Los enlaces son de React Router: llevan a /privacidad, /terminos y /cookies
// sin recargar la página.

import { Link } from 'react-router-dom';
import './PieLegal.css';

const CORREO = 'contacto@non-stop-learning.com';

export default function PieLegal({ className = '' }) {
  const anio = new Date().getFullYear();
  return (
    <p className={`pl-linea ${className}`.trim()} data-prueba="pie-legal">
      <span className="pl-marca">© {anio} Non Stop Learning</span>
      <Link to="/privacidad">Aviso de privacidad</Link>
      <Link to="/terminos">Términos y condiciones</Link>
      <Link to="/cookies">Cookies</Link>
      <a href={`mailto:${CORREO}`}>{CORREO}</a>
    </p>
  );
}
